import { render } from "./SeoAPlusCell.vue?vue&type=template&id=66b16140&scoped=true"
import script from "./SeoAPlusCell.vue?vue&type=script&lang=js"
export * from "./SeoAPlusCell.vue?vue&type=script&lang=js"

import "./SeoAPlusCell.vue?vue&type=style&index=0&id=66b16140&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b16140"]])

export default __exports__